import React from 'react';

import mapModifiers from 'utils/functions';

export const iconList = {
  arrowDown: 'arrowDown',
  badge: 'badge',
  badgeOrange: 'badgeOrange',
  calendar: 'calendar',
  close: 'close',
  closeWhite: 'closeWhite',
  checkOrange: 'checkOrange',
  checkedwhite: 'checkedwhite',
  csv: 'csv',
  download: 'download',
  downloadOrange: 'downloadOrange',
  employee: 'employee',
  employeeOrange: 'employeeOrange',
  export: 'export',
  eye: 'eye',
  eyeOrange: 'eyeOrange',
  eyeSlash: 'eyeSlash',
  eyeWhite: 'eyeWhite',
  email: 'email',
  invalid: 'invalid',
  issue: 'issue',
  file: 'file',
  facebookContact: 'facebookContact',
  logout: 'logout',
  location: 'location',
  linkedInContact: 'linkedInContact',
  hamburger: 'hamburger',
  next: 'next',
  question: 'question',
  plus: 'plus',
  plusCircle: 'plusCircle',
  previous: 'previous',
  philosophy_1: 'philosophy_1',
  philosophy_2: 'philosophy_2',
  philosophy_3: 'philosophy_3',
  search: 'search',
  trash: 'trash',
  upload: 'upload',
  uploadGray: 'uploadGray',
  uploadOrange: 'uploadOrange',
  valid: 'valid',
  warning: 'warning',
  warningRectangle: 'warningRectangle',
  work: 'work',
  world: 'word',
  facebook: 'facebook',
  linkedIn: 'linkedIn',
  youtube: 'youtube',
  zalo: 'zalo',
};

export type IconName = keyof typeof iconList;

export type IconSize = '14' | '16' | '18' | '20' | '24' | '26' | '28' | '30' | '32' | '36' | '40' | '44' | '48' | '54' | '64' | 'full';
interface IconProps {
  iconName: IconName;
  size?: IconSize;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ iconName, size, className }) => (
  <i className={`${mapModifiers('a-icon', iconName, size)} ${className || ''}`} />
);

Icon.defaultProps = {
  size: undefined,
};

export default Icon;
